import { DefaultResponseCodeEnum } from '@workalizer/shared';
export var deleteLabel = function (input) {
    return {
        code: DefaultResponseCodeEnum.SUCCESS,
        success: true
    };
};
